import React from 'react'
import { Link } from "react-router-dom";
import { Disclosure, } from '@headlessui/react'
import { FaBars } from 'react-icons/fa'
import { TfiClose } from 'react-icons/tfi'
import Logo from "../img/Cedonia.png"

export default function Navbar_Cedonia() {
    const navLinks = [
        { name: "Home", to: "/" },
        { name: "About", to: "/about" },
        { name: "Quality", to: "/quality" },
        { name: "Services", to: "/services" },
        { name: "Contact", to: "/contact" },
    ];

    return (
        <Disclosure as="nav" className="sticky top-0 z-40 border-b border-zinc-200/80 bg-white/95 shadow-sm shadow-zinc-900/5 backdrop-blur">
            {({ open }) => (
                <>
                    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div className="relative flex h-20 items-center justify-between">
                            <div className="flex items-center">
                                <div className="flex flex-shrink-0 items-center">
                                    <Link to='/' className="transition duration-200 hover:opacity-80">
                                        <img src={Logo} alt="Logo" className="w-44 sm:w-52" />
                                    </Link>
                                </div>
                            </div>
                            <div className="hidden items-center gap-8 md:flex">
                                <div className="flex items-center gap-1 rounded-full bg-zinc-100 p-1">
                                    {navLinks.map((link) => (
                                        <Link
                                            to={link.to}
                                            className="rounded-full px-4 py-2 text-sm font-semibold text-zinc-700 transition duration-200 hover:bg-white hover:text-red-600 hover:shadow-sm"
                                            key={link.name}
                                        >
                                            {link.name}
                                        </Link>
                                    ))}
                                </div>
                                <Link
                                    to="/contact"
                                    className="inline-flex items-center justify-center rounded-md bg-red-600 px-5 py-3 text-sm font-semibold text-white shadow-sm shadow-red-900/10 transition duration-200 hover:-translate-y-0.5 hover:bg-red-700 hover:shadow-lg hover:shadow-red-900/15"
                                >
                                    Get a Quote
                                </Link>
                            </div>

                            <div className="flex items-center md:hidden">
                                <Disclosure.Button className="inline-flex items-center justify-center rounded-md border border-zinc-200 bg-white p-3 text-zinc-700 shadow-sm transition hover:border-red-200 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-500/30">
                                    <span className="sr-only">Open main menu</span>
                                    {open ? (
                                        <TfiClose className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <FaBars className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>

                        </div>
                    </div>
                    <Disclosure.Panel className="border-t border-zinc-200 bg-white md:hidden">
                        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-4">
                            {navLinks.map((link) => (
                                <Link to={link.to} className="rounded-md px-4 py-3 text-lg font-semibold text-zinc-900 transition hover:bg-zinc-100 hover:text-red-600" key={link.name}>
                                    {link.name}
                                </Link>
                            ))}
                            <Link to="/contact" className="mt-2 rounded-md bg-red-600 px-4 py-3 text-center text-lg font-semibold text-white transition hover:bg-red-700">
                                Get a Quote
                            </Link>
                        </div>
                    </Disclosure.Panel>

                </>
            )}
        </Disclosure>)
}
